export default "__VITE_ASSET__DGL1hTti__"